"use client";

import { Button } from "@/components/atoms/buttons";
import ModalTemplate from "@/components/molecules/modal-template";
import { DialogClose } from "@/components/ui/dialog";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { Loader2 } from "lucide-react";

type ConfirmDeleteProps = {
  title: string;
  modalTrigger: React.ReactNode | string;
  onClick?: () => void;
  text: string;
  locale: Locales;
  open?: boolean;
  isActionHappening?: boolean;
  onOpenChange?: (open: boolean) => void;
};

const ConfirmDelete = ({
  title,
  modalTrigger,
  isActionHappening,
  onClick,
  text,
  locale,
  open,
  onOpenChange,
}: ConfirmDeleteProps) => {
  const isControlled = open !== undefined && onOpenChange !== undefined;

  const dialogProps = isControlled ? { open, onOpenChange } : {};

  return (
    <ModalTemplate
      {...dialogProps}
      classNameTitle="font-cabinet-grotesk"
      title={title}
      triggerAsChild
      modalTrigger={modalTrigger}
    >
      <div className="mx-5 space-y-5 border-t pt-5 pb-5.5">
        <p>{text}</p>
        <div className="flex items-center justify-end gap-2.5">
          <DialogClose asChild>
            <Button disabled={isActionHappening} variant="secondary" className="h-11" size="md">
              {__("Cancel", locale)}
            </Button>
          </DialogClose>
          <Button disabled={isActionHappening} size="md" className="h-11" onClick={() => onClick?.()} variant="danger">
            {isActionHappening && <Loader2 className="mr-2 animate-spin" size={20} aria-hidden="true" />}{" "}
            {__("Delete", locale)}
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
};

export default ConfirmDelete;
